import { render, staticRenderFns } from "./InboxWindowHeadNew.vue?vue&type=template&id=20300983&scoped=true"
import script from "./InboxWindowHeadNew.vue?vue&type=script&lang=ts"
export * from "./InboxWindowHeadNew.vue?vue&type=script&lang=ts"
import style0 from "./InboxWindowHeadNew.vue?vue&type=style&index=0&id=20300983&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20300983",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20300983')) {
      api.createRecord('20300983', component.options)
    } else {
      api.reload('20300983', component.options)
    }
    module.hot.accept("./InboxWindowHeadNew.vue?vue&type=template&id=20300983&scoped=true", function () {
      api.rerender('20300983', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/InboxWindowHeadNew.vue"
export default component.exports